import { ComponentDescription } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

const containerNativeClasses: (string | null | undefined)[] = [
  'FlexBoxLayout',
  'ScrollView',
  'ConditionalRenderer',
  'Recycler',
];

export default function isContainerComponentDescription(componentDescription: ComponentDescription): boolean {
  return componentDescription.container || containerNativeClasses.includes(componentDescription.reactnative_class);
}
